import React from 'react';
import { Route, Routes } from 'react-router-dom';

import AppProvider from './providers/AppProvider';

const RouteSwitch = ({ routePages }) => {
    return (
        <AppProvider>
            <Routes>
                {Object.keys(routePages).map((routeKey) => {
                    const { path, component, ...props } = routePages[routeKey];

                    return (
                        <Route
                            key={routeKey}
                            path={path}
                            element={component}
                            {...props}
                        />
                    );
                })}
            </Routes>
        </AppProvider>
    );
};

export default RouteSwitch;
